import { useSelector } from 'react-redux';

function selectShowFloorplanOnSidePanel(state) {
    return state.ui.sidePanel.floorplan;
}

export function useShowFloorplanOnSidePanel() {
    return useSelector(selectShowFloorplanOnSidePanel);
}
